import { gql } from "generated-graphql";

export const BULK_VERIFY_MUTATION = gql(`
  mutation BulkVerify($reportIds: [ID!]!, $verifier: TierIIReportVerifierInput!) {
    bulkVerifyAndSubmitReports(reportIds: $reportIds, verifier: $verifier) {
      succeeded
    }
  }
`);

export const BULK_VERIFY_VALIDATION_QUERY = gql(`
  query BulkVerifyValidation($reportIds: [ID!]!, $data: TierIIReportVerifier!) {
    bulkTierIIReportVerifierValidator(reportIds: $reportIds, data: $data) {
      key
      message
      level
      metadata
      modelName
    }
  }
`);
